// Import React and required components, images, and styles
import React from "react";
import "../css/ServicesPage.css";
import Hero from "./components/Hero";
import Button from "./components/Button";
import RemortgageImage from "../assets/images/mature-couple-having-meeting-with-bank-manager-signing-lease-agreement-office-focus-is-mature-man.jpg";
import CommercialImage from "../assets/images/male-female-colleagues-greeting-each-other-city.jpg";
import ProtectionImage from "../assets/images/cute-family-playing-summer-field(1).jpg";
import { useNavigate } from "react-router-dom";

// OurServices component displays the services offered by Portfolio Finance
const OurServices = () => {
  const navigate = useNavigate();
  return (
    <div className="services-page">
      {/* Hero section with background image and title */}
      <Hero
        title="OUR SERVICES"
        subtitle=""
        backgroundImage={CommercialImage}
        titleAlign="center"
        subtitleAlign="center"
      />

      {/* Residential mortgages section */}
      <section
        className="service-section commercial-section"
        id="residential-mortgages"
      >
        <div className="service-content">
          <h2 className="service-heading">Residential mortgages</h2>
          <div className="divider align-center"></div>
          <p className="service-description">
            If you’re looking to purchase a home then we can provide you with
            tailored options, and expert mortgage advice. We can support you
            through every step of your home-buying journey.   
          </p>
        </div>
      </section>

      {/* Remortgaging and refinancing section */}
      <section className="service-section remortgage-section" id="remortgage">
        <div className="service-content dark-bg">
          <h2 className="service-heading white-text">
            Remortgaging and refinancing 
          </h2>
          <p className="service-description white-text">
            Whether you’re moving home, or your mortgage is coming up for
            renewal – we can help. With access to a wide range of mortgage
            products, we can find one to fit your needs.
          </p>
          <p
            className="service-description white-text"
            style={{ fontWeight: "bold" }}
          >
            You can begin looking at remortgaging up to six months before your
            fixed term ends. 
          </p>
          {/* Button to contact adviser */}
          <Button
            text="speak to an adviser"
            variant="primary"
            onClick={() => {
              navigate("/contact");
            }}
          />
        </div>

        {/* Remortgage image */}
        <div className="service-image-wrapper">
          <img
            src={RemortgageImage}
            alt="Remortgaging and Refinancing"
            className="service-image"
          />
        </div>
      </section>

      {/* Commercial options section */}
      <section
        className="service-section commercial-section"
        id="commercial-options"
      >
        <div className="service-content">
          <h2 className="service-heading">COMMERCIAL OPTIONS</h2>
          <div className="divider align-center"></div>
          <p className="service-description">
            Portfolio Finance supports business owners, investors, and
            developers with tailored commercial financial solutions. From
            commercial and semi-commercial lending to protection and long-term
            planning, our advice is structured, strategic, and aligned with your
            wider objectives. We provide unparalleled access to mainstream,
            specialist and challenger bank commercial mortgage lenders.  We are
            able to find the best possible commercial mortgage tailored to your
            individual circumstances   
          </p>
        </div>
      </section>

      {/* Protection and insurance planning section */}
      <section
        className="service-section protection-section"
        id="protection-insurance"
      >
        {/* Protection image */}
        <div className="service-image-wrapper">
          <img
            src={ProtectionImage}
            alt="Protection and Insurance Planning"
            className="service-image"
          />
        </div>
        <div className="service-content dark-bg">
          <h2 className="service-heading white-text">
            PROTECTION AND INSURANCE PLANNING
          </h2>
          <p
            className="service-description white-text"
            style={{ fontWeight: "bold" }}
          >
            Protection and insurance are fundamental in giving you peace of mind
            that the things most important to you are secure. 
          </p>
          <p className="service-description white-text">
            Choosing between specific types of insurance is difficult, which is
            why we’re here to guide you through finding a plan to suit you. We
            work with providers in order to offer you an extensive product
            range. 
          </p>
          {/* Regulatory disclaimer */}
          <span
            className="service-description white-text"
            style={{ fontStyle: "italic" }}
          >
            *Your home may be repossessed if you do not keep up repayments on
            your mortgage. 
          </span>
          {/* Button to contact adviser */}
          <Button
            text="speak to an adviser"
            variant="primary"
            onClick={() => {
              navigate("/contact");
            }}
          />
        </div>
      </section>
    </div>
  );
};

// Export the OurServices component as default
export default OurServices;
